import i18n from 'modules/core/lib/i18n'

export const getIncidenceDetailsLabel = (type: string) => {
  switch (type) {
    case 'a3innuva_job_position':
      return i18n.t('bookkeepers.incidence.details.a3innuva_job_position')
    case 'a3nom_error':
      return i18n.t('bookkeepers.incidence.details.a3nom_error')
    case 'acronym':
      return i18n.t('bookkeepers.incidence.details.acronym')
    case 'additional_compensations':
      return i18n.t('bookkeepers.incidence.details.additional_compensations')
    case 'additional_supplement':
      return i18n.t('bookkeepers.incidence.details.additional_supplement')
    case 'additional_supplements':
      return i18n.t('bookkeepers.incidence.details.additional_supplements')
    case 'address':
      return i18n.t('bookkeepers.incidence.details.address')
    case 'address_line_1':
      return i18n.t('bookkeepers.incidence.details.address_line_1')
    case 'additional_contribution_to_nursing_insurance':
      return i18n.t('bookkeepers.incidence.details.additional_contribution_to_nursing_insurance')
    case 'agreement_code':
      return i18n.t('bookkeepers.incidence.details.agreement_code')
    case 'annual_tax_allowance':
      return i18n.t('bookkeepers.incidence.details.annual_tax_allowance')
    case 'attachments':
      return i18n.t('bookkeepers.incidence.details.attachments')
    case 'bank_number':
      return i18n.t('bookkeepers.incidence.details.bank_number')
    case 'birth_name':
      return i18n.t('bookkeepers.incidence.details.birth_name')
    case 'birthday_on':
      return i18n.t('bookkeepers.incidence.details.birthday_on')
    case 'birthplace':
      return i18n.t('bookkeepers.incidence.details.birthplace')
    case 'blank_slate':
      return i18n.t('bookkeepers.incidence.details.blank_slate')
    case 'building_number':
      return i18n.t('bookkeepers.incidence.details.building_number')
    case 'certificate_of_study_expiration_date':
      return i18n.t('bookkeepers.incidence.details.certificate_of_study_expiration_date')
    case 'child_tax_allowance':
      return i18n.t('bookkeepers.incidence.details.child_tax_allowance')
    case 'city':
      return i18n.t('bookkeepers.incidence.details.city')
    case 'civil_status':
      return i18n.t('bookkeepers.incidence.details.civil_status')
    case 'classification':
      return i18n.t('bookkeepers.incidence.details.classification')
    case 'cno_occupation':
      return i18n.t('bookkeepers.incidence.details.cno_occupation')
    case 'coefficient':
      return i18n.t('bookkeepers.incidence.details.coefficient')
    case 'company_identifier':
      return i18n.t('bookkeepers.incidence.details.company_identifier')
    case 'company_number_of_health_insurer':
      return i18n.t('bookkeepers.incidence.details.company_number_of_health_insurer')
    case 'health_insurer_company_number':
      return i18n.t('bookkeepers.incidence.details.health_insurer_company_number')
    case 'contract_effective_date':
      return i18n.t('bookkeepers.incidence.details.contract_effective_date')
    case 'contract_end_date':
      return i18n.t('bookkeepers.incidence.details.new_contract_end_date')
    case 'contract_end_date_undefined':
      return i18n.t('bookkeepers.incidence.details.contract_end_date_undefined')
    case 'contract_observations':
      return i18n.t('bookkeepers.incidence.details.contract_observations')
    case 'contract_start_date':
      return i18n.t('bookkeepers.incidence.details.contract_start_date')
    case 'contract_type':
      return i18n.t('bookkeepers.incidence.details.contract_type')
    case 'contribution_class_health_insurance':
      return i18n.t('bookkeepers.incidence.details.contribution_class_health_insurance')
    case 'contribution_class_nursing_insurance':
      return i18n.t('bookkeepers.incidence.details.contribution_class_nursing_insurance')
    case 'contribution_class_pension_insurance':
      return i18n.t('bookkeepers.incidence.details.contribution_class_pension_insurance')
    case 'contribution_class_unemployment_insurance':
      return i18n.t('bookkeepers.incidence.details.contribution_class_unemployment_insurance')
    case 'contribution_type':
      return i18n.t('bookkeepers.incidence.details.contribution_type')
    case 'cotization_group':
      return i18n.t('bookkeepers.incidence.details.cotization_group')
    case 'country':
      return i18n.t('bookkeepers.incidence.details.country')
    case 'country_of_birth':
      return i18n.t('bookkeepers.incidence.details.country_of_birth')
    case 'datev_employee_code':
      return i18n.t('bookkeepers.incidence.details.datev_employee_code')
    case 'deleted_contract_version':
      return i18n.t('bookkeepers.incidence.details.deleted_contract_version')
    case 'deleted_termination':
      return i18n.t('bookkeepers.incidence.details.deleted_termination')
    case 'deleted_time_off':
      return i18n.t('bookkeepers.incidence.details.deleted_time_off')
    case 'denomination':
      return i18n.t('bookkeepers.incidence.details.denomination')
    case 'description':
      return i18n.t('bookkeepers.incidence.details.description')
    case 'education_level':
      return i18n.t('bookkeepers.incidence.details.education_level')
    case 'effective_date':
      return i18n.t('bookkeepers.incidence.details.new_effective_date')
    case 'effective_on':
      return i18n.t('bookkeepers.incidence.details.effective_on')
    case 'email':
      return i18n.t('bookkeepers.incidence.details.email')
    case 'employee_group':
      return i18n.t('bookkeepers.incidence.details.employee_group')
    case 'empty':
      return i18n.t('bookkeepers.incidence.details.empty')
    case 'ends_on':
      return i18n.t('bookkeepers.incidence.details.ends_on')
    case 'factor':
      return i18n.t('bookkeepers.incidence.details.factor')
    case 'family_situation':
      return i18n.t('bookkeepers.incidence.details.family_situation')
    case 'first_name':
      return i18n.t('bookkeepers.incidence.details.first_name')
    case 'floor':
      return i18n.t('bookkeepers.incidence.details.floor')
    case 'fr_employee_type':
      return i18n.t('bookkeepers.incidence.details.fr_employee_type')
    case 'fr_forfait_jours':
      return i18n.t('bookkeepers.incidence.details.fr_forfait_jours')
    case 'fr_professional_category':
      return i18n.t('bookkeepers.incidence.details.fr_professional_category')
    case 'full_day':
      return i18n.t('bookkeepers.incidence.details.full_day')
    case 'gate':
      return i18n.t('bookkeepers.incidence.details.gate')
    case 'gender':
      return i18n.t('bookkeepers.incidence.details.gender')
    case 'half_day':
      return i18n.t('bookkeepers.incidence.details.half_day')
    case 'has_teleworking_contract':
      return i18n.t('bookkeepers.incidence.details.has_teleworking_contract')
    case 'header':
      return i18n.t('bookkeepers.incidence.details.header')
    case 'health_insurance_id':
      return i18n.t('bookkeepers.incidence.details.health_insurance_id')
    case 'highest_level_of_education':
      return i18n.t('bookkeepers.incidence.details.highest_level_of_education')
    case 'highest_level_of_professional_training':
      return i18n.t('bookkeepers.incidence.details.highest_level_of_professional_training')
    case 'hours':
      return i18n.t('bookkeepers.incidence.details.hours')
    case 'identifier':
      return i18n.t('bookkeepers.incidence.details.identifier')
    case 'identifier_type':
      return i18n.t('bookkeepers.incidence.details.identifier_type')
    case 'irpf':
      return i18n.t('bookkeepers.incidence.details.irpf')
    case 'job_description':
      return i18n.t('bookkeepers.incidence.details.job_description')
    case 'job_level':
      return i18n.t('bookkeepers.incidence.details.job_level')
    case 'job_title':
      return i18n.t('bookkeepers.incidence.details.job_title')
    case 'last_name':
      return i18n.t('bookkeepers.incidence.details.last_name')
    case 'legal_entity':
      return i18n.t('bookkeepers.incidence.details.legal_entity')
    case 'monthly_tax_allowance':
      return i18n.t('bookkeepers.incidence.details.monthly_tax_allowance')
    case 'more_information':
      return i18n.t('bookkeepers.incidence.details.more_information')
    case 'mutual':
      return i18n.t('bookkeepers.incidence.details.mutual')
    case 'nationality':
      return i18n.t('bookkeepers.incidence.details.nationality')
    case 'no_end_date':
      return i18n.t('bookkeepers.incidence.details.no_end_date')
    case 'number_of_dependants':
      return i18n.t('bookkeepers.incidence.details.number_of_dependants')
    case 'observations':
      return i18n.t('bookkeepers.incidence.details.observations')
    case 'occupation_code':
      return i18n.t('bookkeepers.incidence.details.occupation_code')
    case 'payroll_a3nom_integration_code':
      return i18n.t('bookkeepers.incidence.details.payroll_a3nom_integration_code')
    case 'personnel_leasing':
      return i18n.t('bookkeepers.incidence.details.personnel_leasing')
    case 'phone_number':
      return i18n.t('bookkeepers.incidence.details.phone_number')
    case 'place_of_birth':
      return i18n.t('bookkeepers.incidence.details.place_of_birth')
    case 'postal_code':
      return i18n.t('bookkeepers.incidence.details.postal_code')
    case 'professional_category':
      return i18n.t('bookkeepers.incidence.details.professional_category')
    case 'reason':
      return i18n.t('bookkeepers.incidence.details.reason')
    case 'regime':
      return i18n.t('bookkeepers.incidence.details.regime')
    case 'remaining_holidays':
      return i18n.t('bookkeepers.incidence.details.remaining_holidays')
    case 'reported_by':
      return i18n.t('bookkeepers.incidence.details.reported_by')
    case 'reporting_date':
      return i18n.t('bookkeepers.incidence.details.reporting_date')
    case 'requested_annual_allowance':
      return i18n.t('bookkeepers.incidence.details.requested_annual_allowance')
    case 'residency_permit_expiration_date':
      return i18n.t('bookkeepers.incidence.details.residency_permit_expiration_date')
    case 'resident':
      return i18n.t('bookkeepers.incidence.details.resident')
    case 'role_level':
      return i18n.t('bookkeepers.incidence.details.role_level')
    case 'salary_amount':
      return i18n.t('bookkeepers.incidence.details.salary_amount')
    case 'base_salary_amount':
      return i18n.t('bookkeepers.incidence.details.base_salary_amount')
    case 'salary_frequency':
      return i18n.t('bookkeepers.incidence.details.salary_frequency')
    case 'sections':
      return i18n.t('bookkeepers.incidence.details.sections')
    case 'see_absence_detail':
      return i18n.t('bookkeepers.incidence.details.see_absence_detail')
    case 'see_cost_centers':
      return i18n.t('bookkeepers.incidence.details.see_cost_centers')
    case 'see_employee_contract':
      return i18n.t('bookkeepers.incidence.details.see_employee_contract')
    case 'see_employee_contract_documents':
      return i18n.t('bookkeepers.incidence.details.see_employee_contract_documents')
    case 'see_employee_medical_leaves_documents':
      return i18n.t('bookkeepers.incidence.details.see_employee_medical_leaves_documents')
    case 'see_employee_payslip_documents':
      return i18n.t('bookkeepers.incidence.details.see_employee_payslip_documents')
    case 'see_employee_profile':
      return i18n.t('bookkeepers.incidence.details.see_employee_profile')
    case 'see_employee_time_off':
      return i18n.t('bookkeepers.incidence.details.see_employee_time_off')
    case 'see_legal_entity':
      return i18n.t('bookkeepers.incidence.details.see_legal_entity')
    case 'spouses_denomination':
      return i18n.t('bookkeepers.incidence.details.spouses_denomination')
    case 'seniority_calculation_date':
      return i18n.t('bookkeepers.incidence.details.seniority_calculation_date')
    case 'social_security_number':
      return i18n.t('bookkeepers.incidence.details.social_security_number')
    case 'stairwell':
      return i18n.t('bookkeepers.incidence.details.stairwell')
    case 'start_date':
      return i18n.t('bookkeepers.incidence.details.start_date')
    case 'starts_on':
      return i18n.t('bookkeepers.incidence.details.starts_on')
    case 'state':
      return i18n.t('bookkeepers.incidence.details.state')
    case 'street_name':
      return i18n.t('bookkeepers.incidence.details.street_name')
    case 'street_type':
      return i18n.t('bookkeepers.incidence.details.street_type')
    case 'subject':
      return i18n.t('bookkeepers.incidence.details.subject')
    case 'swift_bic':
      return i18n.t('bookkeepers.incidence.details.swift_bic')
    case 'tariff_group':
      return i18n.t('bookkeepers.incidence.details.tariff_group')
    case 'task_documents':
      return i18n.t('bookkeepers.incidence.details.task_documents')
    case 'tax_class':
      return i18n.t('bookkeepers.incidence.details.tax_class')
    case 'tax_id':
      return i18n.t('bookkeepers.incidence.details.tax_id')
    case 'termination_observations':
      return i18n.t('bookkeepers.incidence.details.termination_observations')
    case 'termination_reason':
      return i18n.t('bookkeepers.incidence.details.termination_reason')
    case 'trial_period_ends_on':
      return i18n.t('bookkeepers.incidence.details.trial_period_ends_on')
    case 'type':
      return i18n.t('bookkeepers.incidence.details.type')
    case 'work_permit_expiration_date':
      return i18n.t('bookkeepers.incidence.details.work_permit_expiration_date')
    case 'work_type':
      return i18n.t('bookkeepers.incidence.details.work_type')
    case 'working_day':
      return i18n.t('bookkeepers.incidence.details.working_day')
    case 'working_hours':
      return i18n.t('bookkeepers.incidence.details.working_hours')
    case 'working_hours_frequency':
      return i18n.t('bookkeepers.incidence.details.working_hours_frequency')
    case 'working_week_days':
      return i18n.t('bookkeepers.incidence.details.working_week_days')
    case 'workplace':
      return i18n.t('bookkeepers.incidence.details.workplace')
    case 'de_flat_rate_tax':
      return i18n.t('bookkeepers.incidence.details.de_flat_rate_tax')
    case 'de_activity_type':
      return i18n.t('bookkeepers.incidence.details.de_activity_type')
    case 'de_employment_type':
      return i18n.t('bookkeepers.incidence.details.de_employment_type')
    case 'de_personal_key_group_id':
      return i18n.t('bookkeepers.incidence.details.de_personal_key_group_id')
    case 'teams':
      return i18n.t('bookkeepers.incidence.details.teams')
    case 'de_personal_key_group_name':
      return i18n.t('bookkeepers.incidence.details.de_personal_key_group_name')
    case 'de_base_salary_type_name':
      return i18n.t('bookkeepers.incidence.details.de_base_salary_type_name')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}
